import { FIND_FINANCIAL_GROUP } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
// import utils from "../../../utils";

async function getAllFinancialGroup(props: IFindUserInformation) {
  var thisUrl = FIND_FINANCIAL_GROUP;

  //   const populateFields =
  //     "userTypes avatar balance blocks financial companyInformation.city companyInformation.province companyInformation.nationalCode companyInformation.approved companyInformation.address companyInformation.companyName companyInformation.superAgent";

  //   thisUrl += `&populate=${populateFields}`;

  let body: any = {};
  if (props.page) body = { ...body, page: props.page };
  if (props.limit) body = { ...body, limit: props.limit };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  //   if (props?.search?.value) {
  //     console.log(props?.search?.base);
  //     if (props?.search?.base === "companyInformation.companyName") {
  //       body = {
  //         query: {
  //           ...body.query,
  //           "companyInformation.companyName": { $regex: props?.search?.value },
  //         },
  //       };
  //     } else if (props?.search?.base === "nationalCode") {
  //       body = {
  //         query: {
  //           ...body.query,
  //           "companyInformation.nationalCode": { $regex: props?.search?.value },
  //         },
  //       };
  //     } else {
  //       body = {
  //         query: {
  //           ...body.query,
  //           [String(props.search.base)]: utils.convertNumbers2English(
  //             props.search.value
  //           ),
  //         },
  //       };
  //     }
  //   }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { FinancialGroupType } = props.filters;
    body = {
      ...body,
      type: FinancialGroupType,
    };
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default getAllFinancialGroup;
